import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_24: DocMigration = {
  maxSchemaVersion: "0.0.24",
  apply(json: any) {
    const ignorePaletteKeys = ["type", "name", "thumbnailUrl"];
    if (json.tables && json.tables.palettes) {
      for (const palette of Object.values<any>(json.tables.palettes)) {
        for (const key of Object.keys(palette)) {
          if (ignorePaletteKeys.indexOf(key) < 0) {
            if (typeof palette[key] === "string") {
              palette[key] = { templateId: 2, colorId: 15 }; // Replace with a reasonable fallback color material (SystemColors.Gray70)
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_24;
